/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class AtlasProject {
  /**
  * The name of the project
  */
  'name': string;
  /**
  * The id of the project
  */
  'id': string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "name",
      "baseName": "name",
      "type": "string",
      "format": ""
    },
    {
      "name": "id",
      "baseName": "id",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return AtlasProject.attributeTypeMap;
  }

  public constructor() {
  }
}

